// ============================================================================
// PAYMENTS HOLD BANNER
// ----------------------------------------------------------------------------
// Persistent, non-dismissable notice shown on every page while the admin
// "Payments & KYC Hold" switch is on. Players cannot close it; it goes away
// the moment the switch is turned off (live Firestore listener).
// ============================================================================
import React from 'react';
import { Box, HStack, Text } from '@chakra-ui/react';
import { AlertTriangle } from 'lucide-react';
import { usePaymentsHold } from '../services/paymentsHoldService';

const PaymentsHoldBanner: React.FC = () => {
  const hold = usePaymentsHold();
  if (!hold.enabled) return null;
  const parts: string[] = [];
  if (hold.blockPurchases) parts.push(hold.blockIap ? 'purchases' : 'card purchases');
  if (hold.blockIap && !hold.blockPurchases) parts.push('App Store purchases');
  if (hold.blockKyc) parts.push('ID verification');
  if (hold.blockCashOuts) parts.push('redemptions');
  return (
    <Box
      role="status"
      aria-live="polite"
      bg="linear-gradient(90deg, #7c2d12 0%, #9a3412 50%, #7c2d12 100%)"
      borderBottom="2px solid #fb923c"
      px={4}
      py={3}
      position="relative"
      zIndex={9998}
    >
      <HStack maxW="1100px" mx="auto" spacing={3} align="flex-start" justify="center">
        <Box color="#fb923c" flexShrink={0} mt="2px"><AlertTriangle size={20} /></Box>
        <Box textAlign="center">
          <Text color="white" fontWeight="700" fontSize="sm">
            Payments &amp; ID verification notice
            {parts.length > 0 && (
              <Text as="span" fontWeight="500" color="orange.100"> · {parts.join(', ')} paused</Text>
            )}
          </Text>
          <Text color="rgba(255,255,255,0.92)" fontSize="sm" lineHeight="1.45">{hold.message}</Text>
        </Box>
      </HStack>
    </Box>
  );
};

export default PaymentsHoldBanner;
